











































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import axios from 'axios';

import SitconTatonMask from '@/components/SitconTatonMask.vue';
import BulletScreen from '@/components/CFP/BulletScreen.vue';

import { ThemeType } from '../store/types/app';

import head from '@/util/head';

@Component({
  components: {
    BulletScreen,
    SitconTatonMask
  }
})
export default class Home extends Vue {
  @Action('toggleTheme', { namespace: 'app' }) private toggleTheme!: (theme: ThemeType) => void;

  private sitconTatonMaskHeight: number = 0;
  private sitconTatonMaskWidth: number = 0;
  private defineString: string = '';
  private onSend: boolean = false;
  private bulletScreenWidth: number = 0;
  private bulletScreenHeight: number = 0;

  @Watch('$route')
  public onRouteChange () {
    this.continuePlayVideoWhenFocusBack();
  }

  public mounted () {
    head.reset();
    this.measureMaskSize();
    this.measureBulletScreenSize();
    this.continuePlayVideoWhenFocusBack();
    window.addEventListener('resize', this.measureMaskSize);
    window.addEventListener('resize', this.measureBulletScreenSize);
  }

  public destroyed () {
    window.removeEventListener('resize', this.measureMaskSize);
    window.removeEventListener('resize', this.measureBulletScreenSize);
  }

  private measureMaskSize (): void {
    this.sitconTatonMaskHeight = (this.$refs.sitconTatonMask as Element).clientHeight;
    this.sitconTatonMaskWidth = (this.$refs.sitconTatonMask as Element).clientWidth;
  }

  private continuePlayVideoWhenFocusBack (): void {
    const videoPlayerDOM = document.getElementById('video-player') as HTMLMediaElement;
    if (videoPlayerDOM && videoPlayerDOM.paused) {
      videoPlayerDOM.play();
    }
  }

  private toggleSendAnimate (): void {
    this.onSend = true;
    setTimeout(() => {
      this.defineString = '';
      this.onSend = false;
    }, 3000);
  }

  private measureBulletScreenSize (): void {
    const bulletScreen: any = this.$refs.bulletScreen;

    this.bulletScreenWidth = bulletScreen.clientWidth;
    this.bulletScreenHeight = bulletScreen.clientHeight;
  }

  private async sendDefineForm (): Promise<void> {
    if (this.defineString) {
      try {
        // Detect Egg
        if (this.defineString.toLowerCase().trim().replace(/ /g, '') === 'genderequality') {
          this.toggleTheme(ThemeType.RAINBOW_DARK);
        }

        const defineString = this.defineString;
        this.toggleSendAnimate();
        await axios.post(`https://docs.google.com/forms/d/e/1FAIpQLSf60kH6sRpI_7ctpKi8ptcI7cG2OpvGmW3SjWUGcyiDEekQ4w/formResponse?entry.2121946644=${defineString}`);
      } catch (error) {
        // tslint:disable:no-console
        console.error('Google Form POST', error);
        // tslint:enable
      }
    }
  }
}
